import { useEffect } from 'react';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import { useGetConfigBaseUrlQuery, useUpdateConfigBaseUrlMutation } from '../store/config-api';

import type { TConfigBaseUrl } from '../store/types';

type FormData = TConfigBaseUrl;

export const useConfigBaseUrl = () => {
  const {
    data,
    isLoading: isGetLoading,
    isSuccess: isGetSuccess,
    isError: isGetError,
  } = useGetConfigBaseUrlQuery();

  const [updateBaseUrl, {
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
    isError: isUpdateError,
  }] = useUpdateConfigBaseUrlMutation();

  const isLoading = isGetLoading || isUpdateLoading;
  const isSuccess = isUpdateSuccess;
  const isError = isGetError || isUpdateError;

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      baseUrl: data?.baseUrl || '',
    },
    validate: {
      baseUrl: (value) => !value ? 'Введите Base URL' : null,
    },
  });

  useEffect(() => {
    if (isGetSuccess) {
      form.setValues({ ...data });
    }
  }, [isGetSuccess]);

  const handleBaseUrlUpdate = async (params: TConfigBaseUrl) => {
    await updateBaseUrl(params);
  };

  const handleSubmit = (values: FormData) => {
    modals.openConfirmModal({
      title: 'Сохранение Base URL',
      centered: true,
      children: 'Вы точно хотите сохранить настройки Base URL?',
      labels: { confirm: 'Подтвердить', cancel: 'Отмена' },
      confirmProps: { color: 'blue' },
      onConfirm: () => handleBaseUrlUpdate(values),
    });
  };

  return {
    // data,
    isLoading,
    form,
    // updateBaseUrl,
    // handleBaseUrlUpdate,
    handleSubmit,
  };
};
